function testimonialCarousel(options) {
  $(options.current.querySelector(options.selector+'-slider')).slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      }, {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  });
}




document.addEventListener('DOMContentLoaded', function() {
  window.addEventListener('load', function() {

    var selector = '.testimonials_2021';
    var components = document.querySelectorAll(selector);

    if (components.length > 0) {
      components.forEach(function (component) {
        var config = {
          all: components,
          current: component,
          selector: selector,
        };
  
        testimonialCarousel(config);
      });
    }
  });
});